import React, { useEffect, useState, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Step1 from "./Steps/Step1";
import Step4 from "./Steps/Step4";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import MsgObjetoCreado from "componentes/MsgObjetoCreado";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function getSteps() {
  return ["Datos del Turno", "Datos Personales"];
}

function TurnosForm({
  setStepper,
  turnoInterno = false,
  setMostrarDetalle,
  setNroTurno,
  setNroDoc,
}) {
  const classes = useStyles();
  const [cargando, setCargando] = React.useState(false);

  const [activeStep, setActiveStep] = React.useState(0);
  const [aceptoTerminos, setAceptoTerminos] = React.useState(false);
  const [estaDeshabilitadoAvanzar, setEstaDeshabilitadoAvanzar] =
    React.useState(false);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [creado, setCreado] = useState(null);
  const [datosTurno, setDatosTurno] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  var esCelular = width <= 768;
  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);
  const [modalConfirmar, setModalConfirmar] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const formik = useFormik({
    initialValues: {
      lugarId: "",
      servicioId: "",
      hora: "",
      fecha: "",
      nroDoc: "",
      tipoPadron: "",
      padron: "",
      padronMultiple: false,
      conSuscriptorId: "",
      apellidos: "",
      nombres: "",
      email: "",
      primEmail: "",
      telFijo: "",
      telMovil: "",
      lugares: [],
      servicios: [],
      horas: [],
      tiposPadron: [],
      condSuscriptorOpt: []
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: validationSchema,
    onSubmit: (values, errors) => {
      if (activeStep === steps.length - 1) {
        setModalConfirmar(true);
      } else {
        handleNext();
      }
    },
  });

  const reservarTurno = (values) => {
    setCargando(true)
    var consulta = {
      turno: {
        fecha: values.fecha,
        hora: values.hora,
        servicioId: values.servicioId,
        tipoPadronId: values.tipoPadron,
        padron: values.padron,
        padronMultiple: values.padronMultiple
      },
      solicitante: {
        nroDoc: values.nroDoc,
        nombre: values.nombres,
        apellido: values.apellidos,
        email: values.email,
        telFijo: values.telFijo,
        telMovil: values.telMovil,
        conSuscriptorId: values.conSuscriptorId
      },
    };

    axios
      .post("/turnos/reservar", consulta)
      .then(function (response) {
        setCargando(false)
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setDatosTurno({
            nroTurno: response.data.id,
            nroDoc: values.nroDoc,
          });
          setCreado(true);
        }
      })
      .catch(function (error) {
        setCargando(false)
        setMensajeError(errorBackendMsg(error));
        setShowError(true);
        setMensajeError("Ha ocurrido un error");
        
      });
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Step1 formik={formik} setValidationSchema={setValidationSchema} />
        );
      case 1:
        return (
          <Step4
            formik={formik}
            setValidationSchema={setValidationSchema}
            turnoInterno={turnoInterno}
          />
        );
      default:
        return "Ha ocurrido un error, contacte a soporte";
    }
  };

  return (
    <>
      {creado && (
        <MsgObjetoCreado
          msg={
            "El turno fue reservado correctamente. A continuacion, puede imprimir su comprobante"
          }
          setCreado={setCreado}
          stepper={setStepper}
          turnoInterno={turnoInterno}
          datosTurno={datosTurno}
          setMostrarDetalle={setMostrarDetalle}
          setNroDoc={setNroDoc}
          setNroTurno={setNroTurno}
        />
      )}
      {showError && (
        <MsgGenericoAlerta msg={mensajeError} setVisible={setShowError} />
      )}
      {modalConfirmar && (
        <MsgConfirmacion
          setVisible={setModalConfirmar}
          titulo="Confirmar Reserva"
          msg={
            "¿Desea reservar turno para el día " +
            formik.values.fecha +
            " a las " +
            formik.values.hora +
            "?"
          }
          aceptar={() => {
            reservarTurno(formik.values);
          }}
        />
      )}
      <Backdrop className={classes.backdrop} open={cargando}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stepper
        activeStep={activeStep}
        orientation={esCelular ? "vertical" : "horizontal"}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        <Card style={{ marginTop: 20 }}>
          <CardContent>
            <form onSubmit={formik.handleSubmit}>
              <Typography>{getStepContent(activeStep)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Atras
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() => {
                      console.log(formik);
                    }}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? "Reservar" : "Siguiente"}
                  </Button>
                </div>
              </div>
            </form>
          </CardContent>
        </Card>
      </React.Fragment>
    </>
  );
}

export default TurnosForm;
